<template>
	<module-field :bind="$props">
		<div class="input-box">
			<slug-field v-model="inputVal" :base-field="value[ baseField ]" :enable-tracking="isNew" :editable="editing" :placeholder="field.placeholder"></slug-field>
		</div>
		<div v-if="!editing" class="input-link"><a href @click.prevent="editing = true" tabindex="-1" class="inline-button"><span class="fa fa-pencil"></span>Edit Slug</a></div>
	</module-field>
</template>

<script>

import CrudField from '@/mixins/CrudField';

export default {

	mixins: [ CrudField ],

	data() {
		return {
			baseField: this.field.specific_data,
			editing: !!this.value.isNew,
		};
	},

	computed: {

		isNew() {
			return (!!this.value.isNew);
		},

	},

};
</script>
